import Participant from "./Participant"

class Dealer extends Participant {

}
export default Dealer
